import { FC, ReactNode } from "react";
import { AuthProvider } from "react-oidc-context";

import { AppUser } from "src/authentication/appUser.ts";
import { authConfig } from "src/authentication/authConfig.ts";
import { PermissionsProvider } from "src/authentication/PermissionsProvider";
import { TokenAuthApp } from "src/authentication/TokenApp.tsx";

// Tries to authenticate the user automatically when the app starts if authentication is enabled
export const AuthApp: FC<{ children: ReactNode }> = ({ children }) => {
  if (AppUser.isAuthenticationEnabled) {
    return (
      <AuthProvider {...authConfig}>
        <TokenAuthApp>
          <PermissionsProvider>{children}</PermissionsProvider>
        </TokenAuthApp>
      </AuthProvider>
    );
  }
  return <div>{children}</div>;
};
